<template>
    <div id="spotty-analytics" />
</template>

<script>
import moment from 'moment';

import Utils from '../../js/utils';

export default {
    store: [
        'api',
        'user',
        'currentTab',
        'myTraits', // read to add to user
        'myValueTraits',
        'traitsIndex', // read to add names to analitics etc

    ],
    data () {
        return {};
    },
    mounted: function () { },
    created: function () {
        this.setUpAnalytics();
        this.setupReview();
    },
    methods: {
        setUpAnalytics: function () {
            // setup of all analytics happens here
            // This is firebase
            // Carefull crash if not string eg for userId
            if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics)
                cordova.plugins.firebase.analytics.setCurrentScreen('/start');

            // GA init event is sent in index.ejs
            let prevPage = '';
            this.$events.on('pageChange', page => {
                console.log('[PageView]', page.url)
                if (window.fbq) window.fbq('track', 'PageView');
                if (!page.url) return;
                if (pgap && cordova.plugins && cordova.plugins.SmartlookPlugin) {
                    if (prevPage) {
                        cordova.plugins.SmartlookPlugin.trackNavigationEvent({
                            name: prevPage,
                            viewState: cordova.plugins.SmartlookPlugin.ViewState.STOP                        })
                    }
                    prevPage = page.url;
                    cordova.plugins.SmartlookPlugin.trackNavigationEvent({
                        name: page.url,
                        viewState: cordova.plugins.SmartlookPlugin.ViewState.START                    })
                }
                if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics)
                    cordova.plugins.firebase.analytics.setCurrentScreen(page.url);
                if (!pgap && window.ga) window.ga('send', 'pageview', `/web${page.url}`);
                // if (window.amplitude) {
                //     window.amplitude.getInstance().logEvent('pageview', {
                //         url: page.url,
                //         path: page.url,
                //         item_name: page.name
                //     });
                // }
            });
            this.$events.on('trackEvent', (eventName, type, item_id, item_name, extra) => {
                console.log('[Event]', eventName);
                // internal tracking & datawarehouse
                this.$http
                    .post(`${this.api}/track`, {
                        data: {
                            eventName,
                            eventType: type,
                            item_id,
                            item_name,
                            details: extra,
                        }
                    })
                    .then(() => { })
                    .catch(err => {
                        console.log('Coral track: ', err);
                    });

                // mobile tracking
                // if (pgap) {
                //     if (window.plugins && window.plugins.appsFlyer) {
                //         console.log();
                //         window.plugins.appsFlyer.trackEvent(eventName, {"event_value": ""});
                //         if (eventName === 'subscription_started') { // deprecated
                //             window.plugins.appsFlyer.trackEvent('subscription_initial_purchase', {"event_value": ""});
                //         }
                //     }
                // }
                // // web tracking
                // if (!pgap) {
                //     if (window.AF) {
                //         window.AF('pba', 'event', { eventType: 'EVENT', eventName: eventName, eventLabel: '02', eventRevenue: 0, eventValue: {"event_value": ""} });
                //         if (eventName === 'subscription_started') { // deprecated
                //             window.AF('pba', 'event', { eventType: 'EVENT', eventName: 'subscription_initial_purchase', eventLabel: '02', eventRevenue: 0, eventValue: {"event_value": ""} });
                //         }
                //     }
                // }
                // all events the same both mobile and not
                if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics) {
                    cordova.plugins.firebase.analytics.logEvent(eventName, {
                        content_type: type,
                        value: item_id,
                        item_id: item_id + '',
                        item_name
                    });
                }
                // Google analytics
                // ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject])
                if (!pgap && window.ga) window.ga('send', 'event', type, eventName, item_name, item_id + '');

                // appsflyer
                // it does not seem to differentiate mobile and web
                if (window.plugins && window.plugins.appsFlyer) {
                    console.log("a appsflyer event is happening", eventName)
                    let info = {
                        type,
                        item_id,
                        item_name
                    };
                    if (extra) {
                        info = Utils.extend(info, extra);
                    }

                    // TODO Should use "logEvent" with AppsFlyer SDK v6
                    // and "trackEvent" with v5.
                    // IOS version is already updated, so we need to update an Android app, test it and remove this condition
                    if (window.plugins.appsFlyer.logEvent) {
                        window.plugins.appsFlyer.logEvent(eventName, info);
                    }
                }

                // Regular event with custom params:
                if (window.tapstream && window.tapstream.fireEvent) {
                     let info = {
                        type,
                        item_id,
                        item_name
                    };

                    if (extra) {
                        info = Utils.extend(info, extra);
                    }

                    console.log("a tapstream event is happening", eventName)
                    window.tapstream.fireEvent(eventName, false, info);
                }

                // branch web
                if (window.branch) {
                    window.branch.logEvent(
                        eventName,
                        { item_id, item_name },
                        [], //content_items
                        err => {
                            console.log(err);
                        }
                    );
                }
                // branch mobile
                if (pgap && window.Branch) {
                    window.Branch.userCompletedAction(eventName, { item_id, item_name })
                        .then(res => {
                            console.log('Response: ' + JSON.stringify(res));
                        })
                        .catch(err => {
                            console.error('Error: ' + JSON.stringify(err.message));
                        });
                }
                // smartlook
                if (pgap && cordova.plugins && cordova.plugins.SmartlookPlugin) {
                    if (['subscription_started', 'authentication_register'].indexOf(eventName) > -1) {
                        cordova.plugins.SmartlookPlugin.trackCustomEvent({
                            name: eventName,
                        });
                    }
                }
                // if (window.amplitude) {
                //     window.amplitude.getInstance().logEvent(eventName, {
                //         item_id,
                //         item_name,
                //         properties: extra,
                //     });
                // }
                // if (window.Adjust && window.AdjustEvent) {
                //     let events = {
                //         authentication_register: 'gmuwzb',
                //         course_completed: 'qnwep8',
                //         onboarding_completed: 'unwykl',
                //         pulse_completed: 'vn9ymi',
                //         subscription_skipped: 'qmusl4',
                //         subscription_started: 't4sg7b',
                //         topic_completed: 'v6p14u',
                //         unit_completed: 'rvzvtx'
                //     };
                //     if (events[eventName]) {
                //         var adjustEvent = new window.AdjustEvent(events[eventName]);
                //         window.Adjust.trackEvent(adjustEvent);
                //     }
                // }
            });
            this.$events.fire('trackEvent', 'app_start', 'authentication', 0);
            document.addEventListener(
                'screenshot',
                () => {
                    let url = '';
                    if ($$('#popup').hasClass('modal-in')) {
                        url = f7.views.popup.router.currentRoute.path;
                    } else {
                        url = f7.views.main.router.currentRoute.path;
                    }
                    console.log('screenshot', url);
                    this.$events.fire('trackEvent', 'screenshot', 'share', 1, url);
                },
                false
            );
            this.$events.on('deep-push', (url) => {
                console.log('deep-push', url);
                if (url && url.indexOf('/explore') > -1) {
                    this.currentTab = 'explore';
                } else if (url && url.indexOf('/profile') > -1) {
                    this.currentTab = 'profile';
                } else if (url && url.indexOf('/goals') > -1) {
                    this.currentTab = 'goals';
                }
            });
            this.$events.on('deeplink', (data, url) => {
                console.log('deeplink', data);
                if (url && url.indexOf('/explore') > -1) {
                    this.currentTab = 'explore';
                } else if (url && url.indexOf('/profile') > -1) {
                    this.currentTab = 'profile';
                }
                window.Branch.getFirstReferringParams()
                    .then(branchData => {
                        this.$http
                            .post(`${this.api}/users/${this.user.id}/track`, {
                                attribution: {
                                    idfa: window.localStore.getItem('idfa'),
                                    googleAdId: window.localStore.getItem('googleAdId'),
                                    adjustAdId: window.localStore.getItem('adjustAdId'),
                                    appsflyerId: window.localStore.getItem('appsflyerId'),
                                    branch: pgap ? false : branchData,
                                }
                            })
                            .then(() => { })
                            .catch(err => {
                                console.log('Error branch track: ', err);
                            });
                    })
                    .catch(err1 => {
                        console.error('Error branch track: ', err1);
                    });
            });
            $$(document).on('click', '.page-content .external', e => {
                // console.log('External link tracking', e);
                const url = e.srcElement.href;
                const buttonText = e.srcElement.innerText;
                this.$http
                    .post(`${this.api}/links`, {
                        type: 'external',
                        url,
                        data: {
                            buttonText
                        }
                    })
                    .then(() => { })
                    .catch(err => {
                        console.log('Error link track: ', err);
                    });
            });
            this.$events.on('trackUserLogin', type => {
                let platform = pgap ? device.platform || (f7.device.ios ? 'iOS' : 'Android') : 'web';
                if (!platform) platform = 'iOS';
                if (this.user.isAdmin) {
                    window.localStore.setItem('isAdmin', true);
                }
                console.log('trackUserLogin', type)
                this.$events.fire('trackEvent', `authentication_${type}`, 'authentication');
                const userId = `user${this.user.id}`; // has to be string or crash
                if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics) {
                    cordova.plugins.firebase.analytics.setUserId(userId);
                    cordova.plugins.firebase.analytics.setUserProperty(
                        'unitsCompleted',
                        `${this.user.units_completed}`,
                        () => { },
                        () => { }
                    );
                    cordova.plugins.firebase.analytics.setUserProperty('isAdmin', `${this.user.isAdmin}`, () => { }, () => { });
                }
                if (window.Sentry) {
                    window.Sentry.configureScope(scope => {
                        scope.setUser({ id: userId });
                    });
                }
                if (window.plugins && window.plugins.appsFlyer) {
                    window.plugins.appsFlyer.setAppUserId(userId);
                }
                // if (window.amplitude) {
                //     window.amplitude.getInstance().setUserId(userId);
                //     window.amplitude.getInstance().setUserProperties({
                //         last_seen: new Date(),
                //         $email: this.user.email,
                //         $phone: this.user.phone,
                //         $username: this.user.username,
                //         signInMethod: this.user.email ? 'email' : 'phone',
                //         units_completed: this.user.unitsCompleted,
                //         soft_version: window.version,
                //         platform,
                //         cohort: this.user.cohort,
                //         isSubscribed: this.user.isSubscribed,
                //         day: this.user.day,
                //         sessions: this.user.sessions,
                //         $created: new Date(this.user.createdAt).toISOString(),
                //         created_at: this.user.createdAt,
                //         isAdmin: this.user.isAdmin
                //     });
                // }
                if (pgap) {
                    window.Purchases.setDebugLogsEnabled(true);
                    window.Purchases.setAutomaticAppleSearchAdsAttributionCollection(true);
                    window.Purchases.setup('QngilJQANJodBzZQmgTweOSyplzObrty', userId);
                    window.PurchasesIsSetup = true;
                    window.Purchases.addAttributionData({}, window.Purchases.ATTRIBUTION_NETWORKS.FACEBOOK, userId);
                }
                if (!pgap && window.ga) {
                    window.ga('set', 'userId', userId);
                    window.ga('send', 'event', 'authentication', 'user-id available');
                }
                if (!pgap) {
                    if (window.branch) {

                        // eslint-disable-next-line no-unused-vars
                        window.branch.setIdentity(userId, (err, data) => {

                            // console.log('non pgap branch', data);
                            window.branch.first((err, branchData) => {
                                if (!branchData) branchData = {};
                                let referrer = branchData['$canonical_url'];
                                if (!referrer) referrer = branchData['+referrer']
                                if (!referrer) referrer = window.localStore.getItem('initialReferrer') || ''
                                const attribution = {
                                    referrer,
                                    branch: pgap ? false : branchData,
                                }
                                this.$http
                                    .post(`${this.api}/users/${this.user.id}/track`, {
                                        attribution,
                                    })
                                    .then(
                                        () => { },
                                        err => {
                                            console.log('Error branch track: ', err);
                                        }
                                    );
                            });
                        });
                    } else {
                        let attribution = {
                            referrer: localStore.getItem('initialReferrer') || '',
                        };
                        this.$http
                            .post(`${this.api}/users/${this.user.id}/track`, {
                                attribution,
                            })
                            .then(
                                () => { },
                                err => {
                                    console.log('Error branch track: ', err);
                                }
                            );
                    }
                } else if (pgap && window.Branch) {
                    window.Branch.setIdentity(`user${this.user.id}`)
                        .then(data => {
                            console.log('pgap branch', data);
                            window.Purchases.addAttributionData(data, window.Purchases.ATTRIBUTION_NETWORKS.BRANCH, `user${this.user.id}`)
                            window.Branch.getFirstReferringParams()
                                .then(branchData => {
                                    this.$http
                                        .post(`${this.api}/users/${this.user.id}/track`, {
                                            attribution: {
                                                appsflyerId: window.localStore.getItem('appsflyerId'),
                                                idfa: window.localStore.getItem('idfa'),
                                                googleAdId: window.localStore.getItem('googleAdId'),
                                                adjustAdId: window.localStore.getItem('adjustAdId'),
                                                branch: pgap ? false : branchData,
                                            }
                                        })
                                        .then(() => { })
                                        .catch(err => {
                                            console.log('Error branch track: ', err);
                                        });
                                })
                                .catch(err1 => {
                                    console.error('Error branch track: ', err1);
                                });
                            // if (data.referring_data_parsed) {
                            //  // }
                        })
                        .catch(err => {
                            console.error('Error branch track: ' + JSON.stringify(err.message));
                        });
                }
            });
            // See readme.md on how this should be used
            this.$events.on('trackExperiment', (experimentId, variant, end) => {
                // persist variant
                if (variant !== null) {
                    window.localStore.setItem(`experiment-${experimentId}`, variant);
                } else {
                    variant = parseFloat(window.localStore.getItem(`experiment-${experimentId}`));
                }
            });
            this.$events.on('userPushRegister', data => {});
            this.$events.on('newSubscriber', data => {
                this.$events.fire('trackEvent', 'subscription_started', 'subscription', data ? data.id : 0, data ? data.name : '', data);
                let platform = pgap ? device.platform || (f7.device.ios ? 'iOS' : 'Android') : 'web';
                let update = {
                    last_seen: new Date(),
                    $email: this.user.email,
                    $username: this.user.username,
                    units_completed: this.user.unitsCompleted,
                    soft_version: window.version,
                    platform,
                    cohort: this.user.cohort,
                    is_subscribed: this.user.isSubscribed,
                    subscription_product_id: data ? data.subscription_product_id : '',
                    subscription_sku: data ? data.subscription_sku : '',
                    day: this.user.day,
                    sessions: this.user.sessions,
                    $created: new Date(this.user.createdAt).toISOString(),
                    created_at: this.user.createdAt,
                    isAdmin: this.user.isAdmin
                };
                // if (window.amplitude) {
                //     window.amplitude.getInstance().setUserProperties(update);
                // }
            });
            this.$events.on('userLogout', () => {
                this.$events.fire('trackEvent', 'authentication_logout', 'authentication');
                if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics)
                    cordova.plugins.firebase.analytics.resetAnalyticsData();
                if (!pgap && window.ga) {
                    window.ga('set', 'userId', null);
                    window.ga('send', 'event', 'authentication', 'user logout');
                }
                // if (window.amplitude) {
                //     window.amplitude.getInstance().setUserId(null); // not string 'null'
                //     window.amplitude.getInstance().regenerateDeviceId();
                // }
                if (!pgap && window.branch) {
                    window.branch.logout();
                } else if (window.Branch) {
                    window.Branch.logout();
                }
            });
            this.$events.on('userDelete', () => {
                this.$events.fire('trackEvent', 'authentication_delete', 'authentication');
                if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics)
                    cordova.plugins.firebase.analytics.resetAnalyticsData();
                if (!pgap && window.ga) {
                    window.ga('set', 'userId', null);
                    window.ga('send', 'event', 'authentication', 'user logout');
                }
                // if (window.amplitude) {
                //     window.amplitude.setOptOut();
                //     window.amplitude.getInstance().setUserId(null); // not string 'null'
                //     window.amplitude.getInstance().regenerateDeviceId();
                // }
                if (!pgap && window.branch) {
                    window.branch.logout();
                } else if (window.Branch) {
                    window.Branch.logout();
                }
            });
        },
        setupReview: function () {
            this.$events.on('ask-for-rating', (isAdmin) => {
                if (!pgap) return;
                if (localStore.getItem('ratingAsked')) {
                    let date = moment(localStore.getItem('ratingAsked'));
                    var monthsDiff = date.diff(moment(), 'months');
                    if (monthsDiff < 2 && !isAdmin) return;
                }
                this.$events.fire('trackEvent', 'rating_prompt', 'rating');
                // eslint-disable-next-line no-undef
                AppRate.preferences = {
                    // FEB 2020
                    // 1.1.5 Binary Rejected
                    // We noticed that your app includes content and features that can manipulate the user reviews or chart ranking on the App Store.
                    // enabling simplemode would display the rate dialog directly without the negative feedback filtering flow
                    simpleMode: true, // device.platform === 'iOS' ? true : false,
                    displayAppName: 'Coral',
                    usesUntilPrompt: 3,
                    promptAgainForEachNewVersion: true,
                    inAppReview: true,
                    storeAppURL: {
                        ios: '1448861466',
                        android: 'market://details?id=app.getcoral.m',
                    },
                    customLocale: {
                        title: "Enjoying %@?",
                        message: "If you love using Coral please consider taking a minute to rate it on the store. We appreciate your support!",
                        cancelButtonLabel: "No thanks",
                        laterButtonLabel: "Remind me later",
                        rateButtonLabel: "Rate Coral",
                        yesButtonLabel: "Yes",
                        noButtonLabel: "Not really",
                        appRatePromptTitle: 'Do you love %@?',
                        feedbackPromptTitle: 'We love feedback! Let us know how to make your experience better.',
                    },
                    callbacks: {
                        handleNegativeFeedback: function () {
                            localStore.setItem('ratingAsked', new Date());
                            this.$events.fire('trackEvent', 'rating_negative', 'rating');
                            cordova.plugins.email.open({
                                to: 'support@getcoral.app',
                                subject: 'User satisfaction feedback',
                                body: 'I want to tell you about my experience with Coral...',
                                isHtml: true
                            });
                        },
                        onRateDialogShow: function (callback) {
                            callback(1) // cause immediate click on 'Rate Now' button
                            localStore.setItem('ratingAsked', new Date());
                        },
                        onButtonClicked: function (buttonIndex) {
                            console.log("onButtonClicked -> " + buttonIndex);
                            localStore.setItem('ratingAsked', new Date());
                        }
                    }
                };
                // eslint-disable-next-line no-undef
                AppRate.promptForRating();
            });
        }
    }
};
</script>
<style lang="less" scoped>
#spotty-analytics {
    display: hidden;
}
</style>
